import { render } from "./TemplateVariableTypeComponent.vue?vue&type=template&id=49dbfdb4&scoped=true"
import script from "./TemplateVariableTypeComponent.vue?vue&type=script&lang=js"
export * from "./TemplateVariableTypeComponent.vue?vue&type=script&lang=js"

import "./TemplateVariableTypeComponent.vue?vue&type=style&index=0&id=49dbfdb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dbfdb4"]])

export default __exports__